// 隐私合规Storage键名
export const PRIVACY_STORAGE_KEY = 'sensitive'

// 敏感开关
export const PRIVACY_SWITCH = {
  CLOSE: '0', // 脱敏
  OPEN: '1', // 不脱敏
}
